/**
 * Schema de validação para Log Entries
 * Usado para garantir integridade dos dados em localStorage
 */

export const LOG_ENTRY_SCHEMA = {
  type: 'object',
  required: ['id', 'timestamp', 'sessionId', 'actionType', 'order'],
  properties: {
    id: {
      type: 'string',
      pattern: '^log-\\d+-[a-z0-9]+$'
    },
    timestamp: {
      type: 'number',
      minimum: 0
    },
    sessionId: {
      type: 'string',
      pattern: '^session-\\d+$'
    },
    actionType: {
      type: 'string',
      enum: [
        'UPLOAD_IMAGE',
        'DUPLICATE_IMAGE',
        'REMOVE_IMAGE',
        'MOVE_IMAGE',
        'RESIZE_IMAGE',
        'ROTATE_IMAGE',
        'CHANGE_OPACITY',
        'CHANGE_BLEND_MODE',
        'APPLY_EFFECT',
        'APPLY_COLOR_FILTER',
        'APPLY_CLUT_FILTER',
        'UNDO',
        'REDO',
        'UPDATE_PAPER_SIZE',
        'CHANGE_PAPER_BACKGROUND'
      ]
    },
    order: {
      type: 'number',
      minimum: 0
    },
    imageId: {
      type: ['string', 'null']
    },
    details: {
      type: 'object'
    },
    metadata: {
      type: 'object',
      properties: {
        userAgent: {
          type: 'string'
        },
        viewport: {
          type: 'object',
          properties: {
            width: { type: 'number' },
            height: { type: 'number' }
          }
        }
      }
    }
  },
  additionalProperties: false
};

export const SAVED_LOGS_SCHEMA = {
  type: 'object',
  required: ['sessionId', 'logs'],
  properties: {
    sessionId: {
      type: 'string',
      pattern: '^session-\\d+$'
    },
    logs: {
      type: 'array',
      items: LOG_ENTRY_SCHEMA
    }
  },
  additionalProperties: false
};

/**
 * Schema para sequência de ações exportada
 */
export const ACTION_SEQUENCE_SCHEMA = {
  type: 'object',
  required: ['type', 'version', 'actions'],
  properties: {
    type: {
      type: 'string',
      const: 'pickiwi-action-sequence'
    },
    version: {
      type: 'string',
      pattern: '^\\d+\\.\\d+$'
    },
    actions: {
      type: 'array',
      items: {
        type: 'object',
        required: ['actionType'],
        properties: {
          actionType: {
            type: 'string'
          },
          order: {
            type: 'number',
            minimum: 0
          },
          details: {
            type: 'object'
          }
        }
      }
    }
  },
  additionalProperties: true
};
